import { modalClasses } from '@mui/material/Modal';

/** True while any MUI modal (dialog, drawer, menu) is open: a prompt must not cover what the person opened. */
export const isModalOpen = (): boolean => Boolean(document.querySelector(`.${modalClasses.root}:not(.${modalClasses.hidden})`));
